import React from 'react';

/**
 * Wordmark 1425px x 193px
 * Monogram 369px x 168px
 */

/** Important for storybook! */
import Image4 from '../../images/_RGB_AblerNordic_Monogram-Black.svg';

const LogoMonogramBlack = (props) => {

  const attrs = {
    className: props.className ? props.className : 'max-w-xs',
  };

  const alt = props.alt ? props.alt : 'Abler Nordic Logo';

  return (
    <div {...attrs}>
      <img
        src={Image4}
        className="w-full"
        alt={alt}
        width="369"
        height="168"
        loading="eager"
        fetchPriority="high"
        decoding="sync"
      />
    </div>
  );
};

export {
  LogoMonogramBlack
};